// Convert to Asia/Manila Date object
export const toPH = (d = new Date()) =>
  new Date(d.toLocaleString("en-US", { timeZone: "Asia/Manila" }));

// Format as DB string: YYYY-MM-DD HH:mm:ss.SSS
export const fmtDB = (d) => {
  const pad = (n, w = 2) => String(n).padStart(w, "0");
  return (
    `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ` +
    `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}.` +
    `${String(d.getMilliseconds()).padStart(3, "0")}`
  );
};

/**
 * Business-day window in PH time:
 * - If now < 05:00, anchor = yesterday
 * - Else, anchor = today
 * Window: [anchor 05:00:00.000 → next day 04:59:59.999]
 */
export const getPHWindow_5to459 = (ref = new Date()) => {
  const now = toPH(ref);

  // Anchor date (business day start)
  const anchor = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate() - (now.getHours() < 5 ? 1 : 0),
    0,
    0,
    0,
    0
  );

  const start = new Date(
    anchor.getFullYear(),
    anchor.getMonth(),
    anchor.getDate(),
    5,
    0,
    0,
    0
  );
  const end = new Date(
    anchor.getFullYear(),
    anchor.getMonth(),
    anchor.getDate() + 1,
    7,
    59,
    59,
    999
  );

  return { start, end, anchorDate: anchor }; // anchorDate is the "business date"
};

/**
 * Optional: window for a specific business date (YYYY, M(0-11), D)
 * Always 05:00 of that date to 04:59:59.999 of the next date.
 */
export const getPHWindowForBusinessDate = (y, m, d) => {
  const start = new Date(y, m, d, 5, 0, 0, 0);
  const end = new Date(y, m, d + 1, 7, 59, 59, 999);
  return { start, end };
};
